import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import DialogAdd from './Add'
import Liste from './Liste'
import SearchBar from './SearchBar'
import Title from '../../../SpiderWebSite/components/Title'
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../util/apiClient'
import { useDispatch } from 'react-redux'
import { setAgents, setDroitsDesUtilisateurs, setFilteredUtilisateur, setPersonne, setTypeUtilisateur, setUtilisateur } from './utilisateurAppGestionInterneSlice'



export default function Utilisateur() {

    const dispatch = useDispatch();

    const getUsers = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/utilisateursappgestioninterne");
            if (res.status === 1) {
                dispatch(setUtilisateur(res.data));
                dispatch(setFilteredUtilisateur(res.data));
            } else {
                console.log("status !==1");
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:26 ~ getUsers ~ error:", error)
        }
    };

    const getTypesUser = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/typesutilisateurappgestioninterne");
            if (res.status === 1) {
                dispatch(setTypeUtilisateur(res.data));
            } else {
                console.log("status !==1");
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:26 ~ getUsers ~ error:", error)
        }
    };

    const getPersonnes = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listepersonne");
            if (res.status === 1) {
                dispatch(setPersonne(res.data));
            } else {
                console.log("status !==1");
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:26 ~ getUsers ~ error:", error)
        }
    };

    const getAgents = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listeagents");
            if (res.status === 1) {
                dispatch(setAgents(res.data));
            } else {
                console.log("status !==1");
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:66 ~ getAgents ~ error:", error)
        }
    };

    const getDroitsAgentsUtilisateur = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listedroitsagents");
            if (res.status === 1) {
                dispatch(setDroitsDesUtilisateurs(res.data));
            } else {
                console.log("status !==1");
            }
        } catch (error) {
        console.log("🚀 ~ file: index.tsx:79 ~ getDroitsAgentsUtilisateur ~ error:", error)
        }
    };

    useEffect(() => {
        getUsers()
        getTypesUser()
        getPersonnes()
        getAgents()
        getDroitsAgentsUtilisateur()
    }, []);

    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                {/*---------------- debut titre --------------*/}
                <Title
                    intitule='Liste utilisateur'
                />
                {/*---------------- fin titre --------------*/}


                {/*---------------- debut add --------------*/}

                <Box sx={{ width: "50%" }}>
                    <SearchBar />
                </Box>

                {/*---------------- fin add --------------*/}


                {/*---------------debut SearchBar --------- */}

                <Box>
                    <DialogAdd />
                </Box>

                {/* ------------------fin  SearchBar ------------*/}
            </Box>

            {/*---------------- debut Liste -----------------*/}
            <Liste />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
